// // Angular
// import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
// // RxJS
// import { Observable, Subscription } from 'rxjs';
// // Object-Path
// import * as objectPath from 'object-path';
// // Layout
// import { LayoutConfigService, MenuConfigService, PageConfigService } from '../../../core/_base/layout';
// import { HtmlClassService } from '../html-class.service';
// import { LayoutConfig } from '../../../core/_config/layout.config';
// import { MenuConfig } from '../../../core/_config/menu.config';
// import { PageConfig } from '../../../core/_config/page.config';
// // User permissions
// import { NgxPermissionsService } from 'ngx-permissions';
// import { currentUserPermissions, Permission } from '../../../core/auth';
// import { select, Store } from '@ngrx/store';
// import { AppState } from '../../../core/reducers';
// import { ajaxservice } from '../../../services/ajaxservice';
// import { ToastrService } from 'ngx-toastr';// To use toastr 
// import { Router } from '@angular/router';
// import { TimeoutserviceService } from '../../../core/_base/layout';
// @Component({
// 	selector: 'kt-base',
// 	templateUrl: './base.component.html',
// 	styleUrls: ['./base.component.scss'],
// 	encapsulation: ViewEncapsulation.None
// })
// export class BaseComponent implements OnInit, OnDestroy {
// 	// Public variables
// 	selfLayout: string;
// 	asideDisplay: boolean;
// 	asideSecondary: boolean;
// 	subheaderDisplay: boolean;
// 	desktopHeaderDisplay: boolean;
// 	fitTop: boolean;
// 	fluid: boolean;
// 	employee_code: string
// 	role_id: any;

// 	// Private properties
// 	private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
// 	private currentUserPermissions$: Observable<Permission[]>;


// 	/**
// 	 * Component constructor
// 	 *
// 	 * @param layoutConfigService: LayoutConfigService
// 	 * @param menuConfigService: MenuConfifService
// 	 * @param pageConfigService: PageConfigService
// 	 * @param htmlClassService: HtmlClassService
// 	 * @param store
// 	 * @param permissionsService
// 	 *  @param timeoutservice: TimeoutserviceService
// 	 */
// 	constructor(
// 		private layoutConfigService: LayoutConfigService,
// 		private menuConfigService: MenuConfigService,
// 		private pageConfigService: PageConfigService,
// 		private htmlClassService: HtmlClassService,
// 		private store: Store<AppState>,
// 		private permissionsService: NgxPermissionsService,
// 		private ajax: ajaxservice,
// 		public toastr: ToastrService,
// 		private router: Router,
// 		private timeoutservice: TimeoutserviceService) {
// 		this.loadRolesWithPermissions();

// 		// register configs by demos
// 		this.layoutConfigService.loadConfigs(new LayoutConfig().configs);
	
// 		this.pageConfigService.loadConfigs(new PageConfig().configs);

// 		// setup element classes
// 		this.htmlClassService.setConfig(this.layoutConfigService.getConfig());

// 		const subscr = this.layoutConfigService.onConfigUpdated$.subscribe(layoutConfig => {
// 			// reset body class based on global and page level layout config, refer to html-class.service.ts
// 			document.body.className = '';
// 			this.htmlClassService.setConfig(layoutConfig);
// 		});
// 		this.unsubscribe.push(subscr);
// 	}

// 	/**
// 	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
// 	 */

// 	/**
// 	 * On init
// 	 */
// 	ngOnInit(): void {
// 		// const config = this.layoutConfigService.getConfig();
// 		// this.selfLayout = objectPath.get(config, 'self.layout');
// 		// this.asideDisplay = objectPath.get(config, 'aside.self.display');
// 		// this.subheaderDisplay = objectPath.get(config, 'subheader.display');
// 		// this.desktopHeaderDisplay = objectPath.get(config, 'header.self.fixed.desktop');
// 		// this.fitTop = objectPath.get(config, 'content.fit-top');
// 		// this.fluid = objectPath.get(config, 'content.width') === 'fluid';
// 		// this.menuConfigService.loadConfigs(new MenuConfig().configs);
// 		// // let the layout type change
// 		// const subscr = this.layoutConfigService.onConfigUpdated$.subscribe(cfg => {
// 		// 	setTimeout(() => {
// 		// 		this.selfLayout = objectPath.get(cfg, 'self.layout');
// 		// 	});
// 		// });
// 		// this.unsubscribe.push(subscr);
// 		// //call timeout service here, to ensure timeout occurs even after page is reloaded.
// 		// this.timeoutservice.initListener();
// 		// this.timeoutservice.initInterval();
// 		// this.role_id = localStorage.getItem('pro_role_id');
// 		// if(this.role_id != '10') { //log out if other roles are logged in
// 		// 	this.userlogout();
// 		// }
// 		const config = this.layoutConfigService.getConfig();
// 		this.selfLayout = objectPath.get(config, 'self.layout');
// 		this.asideDisplay = objectPath.get(config, 'aside.self.display');
// 		this.subheaderDisplay = objectPath.get(config, 'subheader.display');
// 		this.desktopHeaderDisplay = objectPath.get(config, 'header.self.fixed.desktop');
// 		this.fitTop = objectPath.get(config, 'content.fit-top');
// 		this.fluid = objectPath.get(config, 'content.width') === 'fluid';
// 		this.menuConfigService.loadConfigs(new MenuConfig().configs);
// 		// let the layout type change
// 		const subscr = this.layoutConfigService.onConfigUpdated$.subscribe(cfg => {
// 			setTimeout(() => {
// 				this.selfLayout = objectPath.get(cfg, 'self.layout');
// 			});
// 		});
// 		this.unsubscribe.push(subscr);
// 	}

// 	/**
// 	 * On destroy
// 	 */
// 	ngOnDestroy(): void {
// 		this.unsubscribe.forEach(sb => sb.unsubscribe());
// 	}

// 	/**
// 	 * NGX Permissions, init roles
// 	 */
// 	loadRolesWithPermissions() {
// 		this.currentUserPermissions$ = this.store.pipe(select(currentUserPermissions));
// 		const subscr = this.currentUserPermissions$.subscribe(res => {
// 			if (!res || res.length === 0) {
// 				return;
// 			}

// 			this.permissionsService.flushPermissions();
// 			res.forEach((pm: Permission) => this.permissionsService.addPermission(pm.name));
// 		});
// 		this.unsubscribe.push(subscr);
// 	}

// 	userlogout() {
// 		this.employee_code = localStorage.getItem('pro_employee_code');
// 		var empid = this.employee_code;
// 		var url = 'fp_logout/?';             // api url for getting the details with using post params
// 		var id = "employee_code";                      //id for using identify the amc name
// 		this.ajax.getdataparam(url, id, empid).subscribe((result) => {
// 			if (result.response.response_code == "200") {
// 				localStorage.removeItem("pro_user_role");
// 				localStorage.removeItem("pro_employee_code");
// 				localStorage.removeItem("pro_employee_id");
// 				localStorage.removeItem("pro_org_type");
// 				localStorage.removeItem("pro_asideMenus");
// 				localStorage.removeItem("pro_user_status");
// 				localStorage.removeItem("pro_role_id");
// 				localStorage.removeItem("pro_organization_type");
// 				localStorage.removeItem("pro_ticket_id");
// 				localStorage.removeItem("pro_layoutConfig");
// 				localStorage.removeItem("pro_user_name");
// 				localStorage.removeItem("pro_bearer_token");
// 				window.location.reload();
// 			}
// 			else if (result.response.response_code == "400") {                //if failure
// 				this.toastr.error(result.response.message, 'Error');            //toastr message for error
// 			}
// 			else if (result.response.response_code == "500") {

// 				this.toastr.error(result.response.message, 'Error');        //toastr message for error
// 				this.router.navigateByUrl('/login')                     //if not sucess
// 			}
// 			else {

// 				this.toastr.error(result.response.message, 'Error');        //toastr message for error

// 			}
// 		}, (err) => {
// 			console.log(err);                                        //prints if it encounters an error
// 		});
// 	}
// }
// Angular
// import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
// // RxJS
// import { Observable, Subscription } from 'rxjs';
// // Object-Path
// import * as objectPath from 'object-path';
// // Layout
// import { LayoutConfigService, MenuConfigService, PageConfigService } from '../../../core/_base/layout';
// import { HtmlClassService } from '../html-class.service';
// import { LayoutConfig } from '../../../core/_config/layout.config';
// import { MenuConfig } from '../../../core/_config/menu.config';
// import { PageConfig } from '../../../core/_config/page.config';
// // User permissions
// import { NgxPermissionsService } from 'ngx-permissions';
// import { currentUserPermissions, Permission } from '../../../core/auth';
// import { select, Store } from '@ngrx/store';
// import { AppState } from '../../../core/reducers';

// @Component({
// 	selector: 'kt-base',
// 	templateUrl: './base.component.html',
// 	styleUrls: ['./base.component.scss'],
// 	encapsulation: ViewEncapsulation.None
// })
// export class BaseComponent implements OnInit, OnDestroy {
// 	// Public variables
// 	selfLayout?: string;
// 	asideDisplay?: boolean;
// 	asideSecondary?: boolean;
// 	subheaderDisplay?: boolean;
// 	desktopHeaderDisplay?: boolean;
// 	fitTop?: boolean;
// 	fluid?: boolean;

// 	// Private properties
// 	private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
// 	private currentUserPermissions$?: Observable<Permission[]>;


// 	/**
// 	 * Component constructor
// 	 *
// 	 * @param layoutConfigService: LayoutConfigService
// 	 * @param menuConfigService: MenuConfifService
// 	 * @param pageConfigService: PageConfigService
// 	 * @param htmlClassService: HtmlClassService
// 	 * @param store
// 	 * @param permissionsService
// 	 */
// 	constructor(
// 		private layoutConfigService: LayoutConfigService,
// 		private menuConfigService: MenuConfigService,
// 		private pageConfigService: PageConfigService,
// 		private htmlClassService: HtmlClassService,
// 		private store: Store<AppState>,
// 		private permissionsService: NgxPermissionsService) {
// 		this.loadRolesWithPermissions();

// 		// register configs by demos
// 		this.layoutConfigService.loadConfigs(new LayoutConfig().configs);
	
// 		this.pageConfigService.loadConfigs(new PageConfig().configs);

// 		// setup element classes
// 		this.htmlClassService.setConfig(this.layoutConfigService.getConfig());

// 		const subscr = this.layoutConfigService.onConfigUpdated$.subscribe(layoutConfig => {
// 			// reset body class based on global and page level layout config, refer to html-class.service.ts
// 			document.body.className = '';
// 			this.htmlClassService.setConfig(layoutConfig);
// 		});
// 		this.unsubscribe.push(subscr);
// 	}

// 	/**
// 	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
// 	 */

// 	/**
// 	 * On init
// 	 */
// 	ngOnInit(): void {
// 		const config = this.layoutConfigService.getConfig();
// 		this.selfLayout = objectPath.get(config, 'self.layout');
// 		this.asideDisplay = objectPath.get(config, 'aside.self.display');
// 		this.subheaderDisplay = objectPath.get(config, 'subheader.display');
// 		this.desktopHeaderDisplay = objectPath.get(config, 'header.self.fixed.desktop');
// 		this.fitTop = objectPath.get(config, 'content.fit-top');
// 		this.fluid = objectPath.get(config, 'content.width') === 'fluid';
// 		this.menuConfigService.loadConfigs(new MenuConfig().configs);
// 		// let the layout type change
// 		const subscr = this.layoutConfigService.onConfigUpdated$.subscribe(cfg => {
// 			setTimeout(() => {
// 				this.selfLayout = objectPath.get(cfg, 'self.layout');
// 			});
// 		});
// 		this.unsubscribe.push(subscr);
// 	}

// 	/**
// 	 * On destroy
// 	 */
// 	ngOnDestroy(): void {
// 		this.unsubscribe.forEach(sb => sb.unsubscribe());
// 	}

// 	/**
// 	 * NGX Permissions, init roles
// 	 */
// 	loadRolesWithPermissions() {
// 		this.currentUserPermissions$ = this.store.pipe(select(currentUserPermissions));
// 		const subscr = this.currentUserPermissions$.subscribe(res => {
// 			if (!res || res.length === 0) {
// 				return;
// 			}

// 			this.permissionsService.flushPermissions();
// 			res.forEach((pm: Permission) => this.permissionsService.addPermission(pm.name));
// 		});
// 		this.unsubscribe.push(subscr);
// 	}
// }

// Angular
import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
// RxJS
import { Observable, Subscription } from 'rxjs';
// Object-Path
import * as objectPath from 'object-path';
// Layout
import { LayoutConfigService, MenuConfigService, PageConfigService } from '../../../core/_base/layout';
import { HtmlClassService } from '../html-class.service';
import { LayoutConfig } from '../../../core/_config/layout.config';
import { MenuConfig } from '../../../core/_config/menu.config';
import { PageConfig } from '../../../core/_config/page.config';
// User permissions
import { NgxPermissionsService } from 'ngx-permissions';
import { currentUserPermissions, Permission } from '../../../core/auth';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../../core/reducers';
import { TimeoutserviceService } from '../../../core/_base/layout';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ajaxservice } from '../../../services/ajaxservice';

@Component({
	selector: 'kt-base',
	templateUrl: './base.component.html',
	styleUrls: ['./base.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class BaseComponent implements OnInit, OnDestroy {
	// Public variables
	selfLayout: string;
	asideDisplay: boolean;
	asideSecondary: boolean;
	subheaderDisplay: boolean;
	desktopHeaderDisplay: boolean;
	fitTop: boolean;
	fluid: boolean;
	employeeCode: string
	roleId: any;

	// Private properties
	private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
	private currentUserPermissions$: Observable<Permission[]>;


	/**
	 * Component constructor
	 *
	 * @param layoutConfigService: LayoutConfigService
	 * @param menuConfigService: MenuConfifService
	 * @param pageConfigService: PageConfigService
	 * @param htmlClassService: HtmlClassService
	 * @param store
	 * @param permissionsService
	 * @param timeoutservice: TimeoutserviceService
	 */
	constructor(
		private layoutConfigService: LayoutConfigService,
		private menuConfigService: MenuConfigService,
		private pageConfigService: PageConfigService,
		private htmlClassService: HtmlClassService,
		private store: Store<AppState>,
		private permissionsService: NgxPermissionsService,
		private ajax: ajaxservice,
		public toastr: ToastrService,
		private router: Router,
		private timeoutservice: TimeoutserviceService) {
		this.loadRolesWithPermissions();

		// register configs by demos
		this.layoutConfigService.loadConfigs(new LayoutConfig().configs);

		this.pageConfigService.loadConfigs(new PageConfig().configs);

		// setup element classes
		this.htmlClassService.setConfig(this.layoutConfigService.getConfig());

		const subscr = this.layoutConfigService.onConfigUpdated$.subscribe(layoutConfig => {
			// reset body class based on global and page level layout config, refer to html-class.service.ts
			document.body.className = '';
			this.htmlClassService.setConfig(layoutConfig);
		});
		this.unsubscribe.push(subscr);
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit(): void {
		const config = this.layoutConfigService.getConfig();
		this.selfLayout = objectPath.get(config, 'self.layout');
		this.asideDisplay = objectPath.get(config, 'aside.self.display');
		this.subheaderDisplay = objectPath.get(config, 'subheader.display');
		this.desktopHeaderDisplay = objectPath.get(config, 'header.self.fixed.desktop');
		this.fitTop = objectPath.get(config, 'content.fit-top');
		this.fluid = objectPath.get(config, 'content.width') === 'fluid';
		this.menuConfigService.loadConfigs(new MenuConfig().configs);
		// let the layout type change
		const subscr = this.layoutConfigService.onConfigUpdated$.subscribe(cfg => {
			setTimeout(() => {
				this.selfLayout = objectPath.get(cfg, 'self.layout');
			});
		});
		this.unsubscribe.push(subscr);
		this.timeoutservice.getRoleBasedIdleTime();
		this.timeoutservice.initListener();
		this.timeoutservice.initInterval();
		this.roleId = localStorage.getItem('pro_role_id');
		console.log(localStorage.getItem('pro_role_id'),"")
		if (this.roleId != '1' && this.roleId != '2' && this.roleId != '3' && this.roleId != '4' 
		&& this.roleId != '5' && this.roleId != '7' && this.roleId != '8' && this.roleId != '9' && this.roleId != '0') { //  log out if other roles are logged in
			this.userlogout();
		}
	}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {
		this.unsubscribe.forEach(sb => sb.unsubscribe());
	}

	/**
	 * NGX Permissions, init roles
	 */
	loadRolesWithPermissions() {
		this.currentUserPermissions$ = this.store.pipe(select(currentUserPermissions));
		const subscr = this.currentUserPermissions$.subscribe(res => {
			if (!res || res.length === 0) {
				return;
			}

			this.permissionsService.flushPermissions();
			res.forEach((pm: Permission) => this.permissionsService.addPermission(pm.name));
		});
		this.unsubscribe.push(subscr);
	}
	userlogout() {
		this.employeeCode = localStorage.getItem('pro_employee_code');
		const empid = this.employeeCode;
		const url = 'fp_logout/?';             // api url for getting the details with using post params
		const id = 'employee_code';                      // id for using identify the amc name
		this.ajax.getdataparam(url, id, empid).subscribe((result) => {
			if (result.response.response_code == "200") {
				localStorage.removeItem('pro_user_role');
				localStorage.removeItem('pro_employee_code');
				localStorage.removeItem('pro_employee_id');
				localStorage.removeItem('pro_org_type');
				localStorage.removeItem('pro_asideMenus');
				localStorage.removeItem('pro_user_status');
				localStorage.removeItem('pro_role_id');
				localStorage.removeItem('pro_organization_type');
				localStorage.removeItem('pro_ticket_id');
				localStorage.removeItem('pro_layoutConfig');
				localStorage.removeItem('pro_user_name');
				localStorage.removeItem('pro_bearer_token');
				window.location.reload();
			}
			else if (result.response.response_code == "400") {                // if failure
				this.toastr.error(result.response.message, 'Error');            // toastr message for error
			}
			else if (result.response.response_code == "500") {

				this.toastr.error(result.response.message, 'Error');        // toastr message for error
				this.router.navigateByUrl('/login')                     // if not sucess
			}
			else {

				this.toastr.error(result.response.message, 'Error');        // toastr message for error

			}
		}, (err) => {
			console.log(err);                                        // prints if it encounters an error
		});
	}
}

